const EG_SETTINGS_KEY = 'EG_SETTINGS_KEY'

const EG_NOTE_DETAIL_FONT_SIZE_MIN = 9
const EG_NOTE_DETAIL_FONT_SIZE_MAX = 18

class SettingsService {
  constructor() {
    this.items = this.load()
  }

  load() {
    const v = localStorage.getItem(EG_SETTINGS_KEY)
    let obj = {}
    if (v) {
      const pv = JSON.parse(v)
      if (pv) {
        obj = pv
      }
    }
    return obj
  }

  save() {
    localStorage.setItem(EG_SETTINGS_KEY, JSON.stringify(this.items))
  }

  getValue(name) {
    const v = this.items[name]
    if (v === undefined) {
      return false
    }
    return v
  }
  setValue(name, v) {
    this.items[name] = v
    this.save()
  }

  // properties

  get theme() {
    return this.getValue('theme')
  }
  set theme(v) {
    this.setValue('theme', v)
  }
  get darkmode() {
    // console.log('setting.theme: ', this.theme)
    switch (Number(this.theme)) {
      case 1:
        // light
        return false
      case 2:
        // dark
        return true
      default: // auto
      {
        const h = new Date().getHours()
        return h < 6 || 18 <= h
      }
    }
  }
  // set darkmode(v) {
  //   this.setValue('darkmode', v)
  // }

  get searchConditionLablesHidden() {
    return this.getValue('searchConditionLablesHidden')
  }
  set searchConditionLablesHidden(v) {
    this.setValue('searchConditionLablesHidden', v)
  }

  get searchToolLablesHidden() {
    return this.getValue('searchToolLablesHidden')
  }
  set searchToolLablesHidden(v) {
    this.setValue('searchToolLablesHidden', v)
  }

  get searchShortcutLabelsHidden() {
    return this.getValue('searchShortcutLabelsHidden')
  }
  set searchShortcutLabelsHidden(v) {
    this.setValue('searchShortcutLabelsHidden', v)
  }

  get fontSize() {
    let v = this.getValue('fonstSize')
    if (v == undefined || !v) {
      v = 14.0
    }
    return v
  }
  set fontSize(v) {
    if (v < EG_NOTE_DETAIL_FONT_SIZE_MIN) {
      v = EG_NOTE_DETAIL_FONT_SIZE_MIN
    } else if (v > EG_NOTE_DETAIL_FONT_SIZE_MAX) {
      v = EG_NOTE_DETAIL_FONT_SIZE_MAX
    }
    this.setValue('fonstSize', v)
  }

  get relatedNoteEnabled() {
    return this.getValue('relatedNoteEnabled')
  }
  set relatedNoteEnabled(v) {
    this.setValue('relatedNoteEnabled', v)
  }

  // get relatedNoteLength() {
  //   return this.getValue('relatedNoteLength') || 2
  // }
  // set relatedNoteLength(v) {
  //   this.setValue('relatedNoteLength', v)
  // }

  get relatedNoteExpanded() {
    return this.getValue('relatedNoteExpanded') || false
  }
  set relatedNoteExpanded(v) {
    this.setValue('relatedNoteExpanded', v)
  }

  get imageDownloadMode() {
    return this.getValue('imageDownloadMode') || '0'
  }
  set imageDownloadMode(v) {
    this.setValue('imageDownloadMode', v)
  }

  get isImageDownloadManual() {
    return this.imageDownloadMode == 1
  }

  get imageDownloadModeList() {
    return [
      { mode: '0', label: '自動ダウンロード', color: 'green' },
      { mode: '1', label: '手動ダウンロード', color: '' }
      // '2': 'Wifi接続時のみ自動'
    ]
  }

  get imageDownloadModeHint() {
    return {
      '0': 'ノートを開いた時に全ての画像が自動でダウンロードされます',
      '1':
        'ノートを開いた時に画像はダウンロードされません。ただし過去にダウンロードされた（キャッシュされた）画像は表示されます。'
      // '2':
      //   'Wifi接続でノートを開いた時に全ての画像が自動でダウンロードされます。Wifi以外の場合は手動となります。※iOS Safariなど一部ブラウザは非対応',
    }[this.imageDownloadMode]
  }

  // get searchSetOpened() {
  //   return this.getValue('searchSetOpened')
  // }
  // set searchSetOpened(v) {
  //   this.setValue('searchSetOpened', v)
  // }
}

const settingsService = new SettingsService()
export default settingsService
